import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';



class AlterarSenha extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      senhaAtual: {valor: '', erro: ''},
      senhaNova: {valor: '', erro: ''},
      senhaNova2: {valor: '', erro: ''},
      loading: false,
      snackError: false,
      snackMsg: '',
    };

  }

  updateSenha(e) {
    let state = this.state;
    state.senhaNova2.erro = '';
    state[e.target.name].valor = e.target.value;
    
    // Valida a nova senha enquanto digita
    if (e.target.name === 'senhaNova') {
      state.senhaNova.erro = this.validarSenha(e.target.value);
    }
    
    this.setState(state);
  }

  validarSenha(senha) {
    if (senha.length === 0) {
      return '';
    }

    let erros = [];
    
    // Verifica se tem pelo menos uma letra maiúscula
    if (!/[A-Z]/.test(senha)) {
      erros.push('letra maiúscula');
    }
    
    // Verifica se tem número OU caractere especial
    const temNumero = /[0-9]/.test(senha);
    const temCaractereEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha);
    
    if (!temNumero && !temCaractereEspecial) {
      erros.push('número ou caractere especial');
    }
    
    // Verifica tamanho mínimo
    if (senha.length < 8) {
      erros.push('mínimo de 8 caracteres');
    }

    if (erros.length > 0) {
      return 'A senha precisa ter: ' + erros.join(', ') + '.';
    }

    return '';
  }

  verificaSenhas() {
    let state = this.state;

    // Valida a nova senha se ainda não foi validada
    if (state.senhaNova.valor.length > 0 && state.senhaNova.erro === '') {
      state.senhaNova.erro = this.validarSenha(state.senhaNova.valor);
    }

    // As duas senhas com conteúdo
    if (state.senhaNova.valor.length > 0 && state.senhaNova2.valor.length > 0) {
      if (state.senhaNova.valor !== state.senhaNova2.valor)
        state.senhaNova2.erro = 'Senhas precisam ser iguais.';
      else
        state.senhaNova2.erro = '';
    }
    else
      state.senhaNova2.erro = '';

    this.setState(state);
  }

  verificaCamposObrigatorios () {
    let state = this.state;
    let obrigatorios = ['senhaAtual', 'senhaNova', 'senhaNova2'];
    let semErro = true;

    for (let i = 0; i < obrigatorios.length; i++) {
      if (state[obrigatorios[i]].valor.length === 0) {
        state[obrigatorios[i]].erro = 'Campo obrigatório.';
        semErro = false;
      }
    }

    return semErro;
  }

  verificaCamposComErro () {
    let state = this.state;
    let obrigatorios = ['senhaAtual', 'senhaNova', 'senhaNova2'];
    let semErro = true;

    for (let i = 0; i < obrigatorios.length; i++) {
      if (state[obrigatorios[i]].erro.length > 0) {
        semErro = false;
        break;
      }
    }

    return semErro;
  }

  irTelaLogin() {
    this.props.history.push(`${process.env.PUBLIC_URL}/sair`);
  }

  trocarSenha() {
    let state = this.state;
    
    // Valida a senha antes de enviar
    if (state.senhaNova.valor.length > 0) {
      state.senhaNova.erro = this.validarSenha(state.senhaNova.valor);
    }
    
    state.loading = true;
    this.setState(state);

    if (this.verificaCamposObrigatorios()) {
      if (this.verificaCamposComErro()) {
        let token = localStorage.getItem('planos_t');
        let camposEnvio = {
          oldPassword: this.state.senhaAtual.valor,
          newPassword: this.state.senhaNova.valor,
        };
        
        axios.post(configBase.api + 'Accounts/change-password?access_token=' + token, camposEnvio)
        .then(() => {
          // Seta access_token
          localStorage.setItem('planos_ns', 'true');

          this.irTelaLogin();
        })
        .catch(function (erro) {
          let state = this.state;
          state.loading = false;
          state.snackError = true;

          if (erro.response) {
            // Tenta pegar a mensagem de erro do servidor
            if (erro.response.data && erro.response.data.error && erro.response.data.error.message) {
              state.snackMsg = erro.response.data.error.message;
            } else if (erro.response.status === 401) {
              state.snackMsg = 'Token de autenticação inválido ou expirado.';
            } else if (erro.response.status === 400) {
              state.snackMsg = 'Senha atual incorreta.';
            } else {
              state.snackMsg = 'Erro ao alterar senha. Tente novamente.';
            }
          }
          else
            state.snackMsg = 'Problema encontrado ao tentar cadastrar nova senha.';
            
          this.setState(state);
        }.bind(this));
      }
      else {
        state.loading = false;
        state.snackError = true;
        state.snackMsg = 'Campos com erro.';
        this.setState(state);
      }
    }
    else {
      state.loading = false;
      state.snackError = true;
      state.snackMsg = 'Campos obrigatórios.';
      this.setState(state);
    }
  }

  handleClose() {
    let state = this.state;
    state.snackError = false;
    this.setState(state);
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="alterarsenha" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              ALTERAR SENHA DE ACESSO
            </Typography>
          </Paper>

          <div className="contentepanel">
            <Card>
              <div>
                <Grid container spacing={2} style={{padding: '15px 15px 0 15px'}}>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <TextField
                      fullWidth
                      error={this.state.senhaAtual.erro.length > 0 ? (true):(false)}
                      helperText={this.state.senhaAtual.erro}
                      label="Senha Atual *"
                      variant="outlined"
                      size="small"
                      name="senhaAtual"
                      type="password"
                      value={this.state.senhaAtual.valor}
                      onChange={this.updateSenha.bind(this)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                </Grid>

                <Grid container spacing={2} style={{padding: '0 15px 0 15px'}}>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <TextField
                      fullWidth
                      error={this.state.senhaNova.erro.length > 0 ? (true):(false)}
                      helperText={this.state.senhaNova.erro}
                      label="Nova Senha *"
                      variant="outlined"
                      size="small"
                      name="senhaNova"
                      type="password"
                      value={this.state.senhaNova.valor}
                      onChange={this.updateSenha.bind(this)}
                      onBlur={this.verificaSenhas.bind(this)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                </Grid>

                <Grid container spacing={2} style={{padding: '0 15px 0 15px'}}>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <TextField
                      fullWidth
                      error={this.state.senhaNova2.erro.length > 0 ? (true):(false)}
                      helperText={this.state.senhaNova2.erro}
                      label="Nova Senha *"
                      variant="outlined"
                      size="small"
                      name="senhaNova2"
                      type="password"
                      value={this.state.senhaNova2.valor}
                      onChange={this.updateSenha.bind(this)}
                      onBlur={this.verificaSenhas.bind(this)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                </Grid>

                <Grid container spacing={2} style={{padding: '0 15px 0 15px'}}>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <div id="botaoLogin" className="containerButton">
                      <Button
                        disabled={this.state.loading}
                        style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                        color="primary"
                        fullWidth
                        size="medium"
                        type="submit"
                        variant="contained"
                        onClick={this.trocarSenha.bind(this)}
                      >
                        ALTERAR SENHA
                      </Button>

                      {
                        this.state.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }

                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={4}></Grid>
                </Grid>
              </div>
            </Card>
          </div>

          <Snackbar open={this.state.snackError} autoHideDuration={5000} onClose={this.handleClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.handleClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.snackMsg}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

AlterarSenha.propTypes = {
  history: PropTypes.object
};

export default withRouter(AlterarSenha);
